import React from 'react';
import { Link } from 'react-router-dom';
import { buildLeadNarrative, buildStatColumns, buildSuggestion } from '../utils/narrative';

// The top of the Analytics screen: the takeaway in a sentence, the numbers it
// leans on as bare columns (no boxes), and the one thing worth doing next.
export default function InsightsLead({ data }) {
  const narrative = buildLeadNarrative(data);
  const columns = buildStatColumns(data);
  const suggestion = buildSuggestion(data);
  const milestone = data?.nextMilestone;

  return (
    <section className="ins-lead">
      <div className="ins-lead-main">
        <p className="ins-lead-sentence">
          {narrative
            ? narrative.map((part, i) => (
                <span key={i} style={part.strong ? { fontWeight: 600 } : undefined}>
                  {part.text}
                </span>
              ))
            : 'Your learning story starts with your first lesson — once you have one, this is where the numbers show up.'}
        </p>

        {columns.length > 0 && (
          <div className="ins-stat-row">
            {columns.map((column) => (
              <div className="ins-stat" key={column.label}>
                <div className="ins-stat-value">{column.value}</div>
                <div className="ins-stat-label">{column.label}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {suggestion && (
        <aside className="pp-card ins-suggest">
          <p className="ins-eyebrow">Suggested next</p>
          <p
            style={{
              margin: '0 0 6px',
              fontSize: 15,
              lineHeight: 1.4,
              fontWeight: 600,
              letterSpacing: '-0.01em',
              color: 'var(--text-primary)',
            }}
          >
            {suggestion.title}
          </p>
          <p style={{ margin: '0 0 14px', fontSize: 13, lineHeight: 1.55, color: 'var(--text-secondary)' }}>
            {suggestion.body}
          </p>
          {suggestion.action.to ? (
            <Link className="ins-btn" to={suggestion.action.to}>
              {suggestion.action.label}
            </Link>
          ) : (
            <a className="ins-btn" href={suggestion.action.href}>
              {suggestion.action.label}
            </a>
          )}

          {milestone && (
            <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid var(--border-subtle)' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: 10,
                  marginBottom: 6,
                  fontSize: 12,
                  color: 'var(--text-tertiary)',
                }}
              >
                <span>Next badge · {milestone.name}</span>
                <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                  {milestone.current}/{milestone.target}
                </span>
              </div>
              <div className="ins-meter-track" style={{ height: 6 }}>
                <div
                  className="ins-meter-fill"
                  style={{
                    width: `${Math.min(Math.max(milestone.progressPercent ?? 0, 0), 1) * 100}%`,
                    background: 'var(--accent-primary)',
                  }}
                />
              </div>
            </div>
          )}
        </aside>
      )}
    </section>
  );
}
